const SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;

export default function normalizeHttpUrl(value) {
  const trimmed = String(value ?? '').trim();
  if (trimmed === '') {
    return null;
  }

  let parsed;
  try {
    parsed = new URL(SCHEME.test(trimmed) ? trimmed : `https://${trimmed}`);
  } catch {
    return null;
  }

  if (!/^https?:$/.test(parsed.protocol)) {
    return null;
  }

  const host = parsed.hostname;
  if (!host.includes('.') || host.startsWith('.') || host.endsWith('.')) {
    return null;
  }

  return parsed.href;
}
